import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { TIME_REGEX } from 'src/utilities/regexPatterns';
import {
  calculateTimeIntervalTypeUpdate,
  TimeIntervalTypeAutoUpdateParams,
} from './useTimeIntervalTypeAutoUpdate.utils';

// Automatically switches time interval type (ALL_DAY/HOURS/OVERNIGHT) based on start/end times
export const useTimeIntervalTypeAutoUpdate = (): void => {
  const { getValues, setValue } = useFormContext<IMealCreditFormFields>();

  const {
    formValues: { startTime, startTimeMeridian, endTime, endTimeMeridian },
  } = useMealCreditFormData();

  useEffect(() => {
    const { timeIntervalType } = getValues();
    const params: TimeIntervalTypeAutoUpdateParams = {
      timeIntervalType,
      startTime,
      startTimeMeridian,
      endTime,
      endTimeMeridian,
      hasStartTimeError: !TIME_REGEX.test(startTime),
      hasEndTimeError: !TIME_REGEX.test(endTime),
    };

    const newTimeIntervalType = calculateTimeIntervalTypeUpdate(params);

    if (newTimeIntervalType) {
      setValue('timeIntervalType', newTimeIntervalType);
    }
  }, [
    startTime,
    startTimeMeridian,
    endTime,
    endTimeMeridian,
    getValues,
    setValue,
  ]);
};
